import React, { useState } from 'react';
import { isBlank, isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { pathOr, find, propEq } from 'ramda';

import useFirebaseChat from 'reducers/hooks/firebase/useChat';

import UserPresenter from 'presenters/UserPresenter';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';
import ChatPresenter from 'presenters/ChatPresenter';
import ChatListPage from './components/ChatListPage';
import ChatPage from './components/ChatPage';
import LoanOfficerPage from './components/LoanOfficerPage';

import useStyles from './useStyles';

const MobileMessages = props => {
  const classes = useStyles();
  const {
    isOnline,
    currentUser,
    onChatSelect,
    onMessageSend,
    onMessagesRead,
    selectedChatUid,
    chats,
    chatsInfo,
    onUnselectChat,
  } = props;

  const { messages, isMessagesLoading, usersOnlineStatusList } = useFirebaseChat();

  const [showLoanOfficerPage, setShowLoanOfficerPage] = useState(false);
  const isChatSelected = isPresent(selectedChatUid);

  const handleOpenLoanOfficerPage = () => setShowLoanOfficerPage(true);
  const handleCloseLoanOfficerPage = () => setShowLoanOfficerPage(false);

  if (!isChatSelected) {
    return (
      <div className={classes.paper}>
        <ChatListPage chats={chats} chatsInfo={chatsInfo} onChatSelect={onChatSelect} />
      </div>
    );
  }

  const selectedChat = find(propEq('uid', selectedChatUid), chats);
  const loanOfficerId = FirebaseChatPresenter.loanOfficerId(selectedChat);
  const isOnlineSelectedChatLoanOfficer = pathOr(false, [loanOfficerId, 'isOnline'], usersOnlineStatusList);
  const bid = FirebaseChatPresenter.latestBid(selectedChat);
  const selectedChatInfo = chatsInfo[selectedChatUid];
  const loanOfficer = isBlank(selectedChatInfo) ? null : ChatPresenter.loanOfficer(selectedChatInfo);
  const selectedChatMessages = messages[selectedChatUid];

  if (showLoanOfficerPage) {
    return <LoanOfficerPage loanOfficer={loanOfficer} bid={bid} onBack={handleCloseLoanOfficerPage} />;
  }

  return (
    <div className={classes.root}>
      <ChatPage
        chat={selectedChat}
        isOnline={isOnline}
        currentUser={currentUser}
        isParticipantOnline={isOnlineSelectedChatLoanOfficer}
        onMessageSend={onMessageSend}
        onMessagesRead={onMessagesRead}
        onBack={onUnselectChat}
        loanOfficer={loanOfficer}
        selectedChatUid={selectedChatUid}
        chatInfo={selectedChatInfo}
        bid={bid}
        messages={selectedChatMessages}
        isMessagesLoading={isMessagesLoading}
        loanOfficerId={loanOfficerId}
        onOpenLoanOfficerPage={handleOpenLoanOfficerPage}
      />
    </div>
  );
};

MobileMessages.propTypes = {
  isOnline: PropTypes.bool.isRequired,
  currentUser: UserPresenter.shape().isRequired,
  onChatSelect: PropTypes.func.isRequired,
  onMessageSend: PropTypes.func.isRequired,
  onMessagesRead: PropTypes.func.isRequired,
  selectedChatUid: PropTypes.string,
  chats: PropTypes.arrayOf(FirebaseChatPresenter.shape()).isRequired,
  chatsInfo: PropTypes.shape().isRequired,
  onUnselectChat: PropTypes.func.isRequired,
};

MobileMessages.defaultProps = {
  selectedChatUid: '',
};

export default MobileMessages;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/MobileMessages.js